// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__16zVc","label":"Labeled_label__yGnng","divider":"Labeled_divider__544BX"};